export default function AdminAbandonedCarts() {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Abandoned Carts</h2>
      <p className="text-gray-500">Coming soon – this will show customers who started but didn't finish checkout.</p>
    </div>
  );
}